export enum UsersActionMessageEnum {
  INVITE_SUCCESS = 'User invite sent',
  UPDATE_SUCCESS = 'User updated',
}
